import { graphql } from '@/generated/gql';

export const PROCUREMENT_KNOWLEDGE_DELETE_MUTATION = graphql(/* GraphQL */ `
  mutation DeleteProcurementKnowledgeDocument($docId: UUID!) {
    sevenbridges {
      document {
        delete(id: $docId) {
          ...ProcurementKnowledgeDocument
        }
      }
    }
  }
`);
